export const Footer = () => (
  <footer className="bg-ink text-cream" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-8 md:py-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <p className="overline text-yellow">The Wedding Of</p>
          <h2 className="font-display text-3xl md:text-4xl mt-2">Dan &amp; Maggie</h2>
          <p className="font-grotesk mt-2 text-cream/80">May 22, 2027 · Save the date</p>
        </div>
      </div>
      <div className="mt-6 pt-5 border-t border-cream/20 flex flex-col md:flex-row justify-between gap-2 text-sm text-cream/60 font-body">
        <span>Made with love · See you on the dance floor ✦</span>
        <span>© 2027 Dan &amp; Maggie</span>
      </div>
    </div>
  </footer>
);
